import type { SavedCardPaymentMethod, SavedPaymentMethod } from '@/classes/stripe';

export type PaymentMethodTranslateFn = (key: string) => string;

function getWalletTypeLabel(card: SavedCardPaymentMethod, t: PaymentMethodTranslateFn): string | null {
  if (!card.is_wallet || !card.wallet_type) {
    return null;
  }

  const key = `fields.checkout.payment_methods.${card.wallet_type}`;
  const label = t(key);
  return label === key ? card.wallet_type : label;
}

/** Email shown beside PayPal / Klarna in the Billing payment-method list. */
export function getSavedPaymentMethodEmail(method: SavedPaymentMethod): string {
  if (method.type === 'paypal' || method.type === 'klarna') {
    // Default summary uses `email`; saved-methods list uses `payer_email`.
    return method.email ?? method.payer_email ?? '';
  }

  return '';
}

/** Human-readable type / brand label for a saved payment method (matches Billing list UI). */
export function getSavedPaymentMethodTypeLabel(method: SavedPaymentMethod, t: PaymentMethodTranslateFn): string {
  switch (method.type) {
    case 'paypal':
      return t('fields.checkout.payment_methods.paypal');
    case 'klarna':
      return t('fields.checkout.payment_methods.klarna');
    case 'sepa_debit':
      return t('fields.checkout.payment_methods.sepa_debit');
    case 'pix':
      return t('fields.checkout.payment_methods.pix');
    case 'bank_transfer':
      return t('fields.checkout.payment_methods.send_invoice');
    case 'card':
      return getWalletTypeLabel(method, t) ?? method.brand ?? t('fields.checkout.payment_methods.card');
    default:
      return t('fields.checkout.payment_methods.card');
  }
}
